import { RequestCustomerStatus, getContactDetailsStatusEndpoint } from 'cpfr-common';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';
import { getSimpleDataFetchSlice } from '@cp-shared-19/frontend-integration';
import { CpDataApi } from 'cp-xhr';

const { reducer, fetchData, updateData } = getSimpleDataFetchSlice<
    RequestCustomerStatus,
    DefaultBusinessMarketApiErrorCode
>({
    dataName: 'ContactInformationChangeStatus',
    fetchCallback() {
        return CpDataApi.get<RequestCustomerStatus>(getContactDetailsStatusEndpoint()).then(
            (response) => response.data,
        );
    },
});

export default reducer;
export const fetchContactInformationChangeStatus = fetchData;
export const updateContactInformationChangeStatus = updateData;
